import { Directive, ElementRef, HostListener, inject } from "@angular/core";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";

/**
 * Escape inside an open ng-bootstrap dropdown menu (ng22 WP8): close it and put
 * focus back on the toggle. ng-bootstrap closes on Escape through a document
 * listener but leaves focus on the now-hidden item, i.e. on the body.
 * Opt-in per menu: `ngbDropdownMenu appMenuKeys`.
 */
@Directive({ selector: "[appMenuKeys]" })
export class NgbDropdownMenuKeysDirective {
  private readonly dropdown = inject(NgbDropdown);
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);

  @HostListener("keydown.escape", ["$event"])
  onEscape(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.dropdown.close();
    this.element.nativeElement.parentElement?.querySelector<HTMLElement>("[ngbDropdownToggle]")?.focus();
  }
}
